import Data from 'react-k2-api/Api/Data'
import PrimaryKey from 'react-k2-api/Api/PrimaryKey'
import { Type } from 'class-transformer'
import TK2UserLookupDM from './TK2UserLookupDM'
import TCodeTypeDM from './TCodeTypeDM'
import TLanguageMemoTranslationDM from './TLanguageMemoTranslationDM'

/**
 * Komentáře
 */
export default class TCommentDM extends Data {
	public static className = 'TCommentDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	public static isHeader = false

	/**
	 * Změněno
	 */
	ChangedOn?: Date

	/**
	 * Vytvořeno
	 */
	CreatedOn?: Date

	/**
	 * TableID
	 */
	TableId?: number

	/**
	 * Právo na záznam
	 */
	RightGroupId?: number

	/**
	 * Pořadí
	 */
	SequenceNumber?: number

	/**
	 * Vlastník
	 */
	MasterRID?: number

	/**
	 * Číslo
	 */
	RID?: number

	/**
	 * undefined
	 */
	RecordMod?: number

	/**
	 * undefined
	 */
	RecordES?: number

	/**
	 * Číslo
	 */
	RecordID?: number

	/**
	 * undefined
	 */
	RecordState?: number

	/**
	 * s
	 */
	SelectionImgCalc?: string

	/**
	 * LegislationContext
	 */
	LegislationContextCalc?: number

	/**
	 * Datum
	 */
	CurrentDateCalc?: Date

	/**
	 * Čas
	 */
	CurrentTimeCalc?: Date

	/**
	 * Komentář 100
	 */
	Content100Calc?: string

	/**
	 * Komentář
	 */
	ContentCalc?: string

	/**
	 * undefined
	 */
	PlainContentCalc?: string

	/**
	 * Komentář 300
	 */
	Content300Calc?: string

	/**
	 * Právo na záznam
	 */
	RightGroupIdCalc?: number

	/**
	 * Změnil
	 */
	@Type(() => TK2UserLookupDM)
	ChangedById?: TK2UserLookupDM

	/**
	 * Vytvořil
	 */
	@Type(() => TK2UserLookupDM)
	CreatedById?: TK2UserLookupDM

	/**
	 * Typ
	 */
	@Type(() => TCodeTypeDM)
	TypeId?: TCodeTypeDM

	/**
	 * undefined
	 */
	@Type(() => TLanguageMemoTranslationDM)
	ContentChild?: TLanguageMemoTranslationDM[]
}